<div class="collapse w-100" id="navbarToggleExternalContent">
    <div class="bg-dark">
      <h4 class="text-white">Collapsed content</h4>
      <span class="text-muted">Toggleable via the navbar brand.</span>
    </div>
  </div>
  <nav class="navbar navbar-dark bg-dark header">
    <img src="assets/images/logo1.png" alt="" class="ml-2" />
  </nav>
  